////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { useSelector, shallowEqual } from 'react-redux'
/////////ASSETS/////////
import Check from '../../../assets/icones/global/check-green.svg'
import Cancel from '../../../assets/icones/global/close-red.svg'

/////////STYLED/////////
const DistributionGroupRepositoryDescriptionWrapper = styled.img`
	max-height: 40px;
	max-width: 40px;
`
/////////STYLED/////////

const DistributionGroupRepositoryDescription = (props) => {
	let description = props.row.withDescription?.boolValue
	useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<>
			{description ? (
				<DistributionGroupRepositoryDescriptionWrapper src={Check} />
			) : (
				<DistributionGroupRepositoryDescriptionWrapper src={Cancel} />
			)}
		</>
	)
}

DistributionGroupRepositoryDescription.propTypes = {}

DistributionGroupRepositoryDescription.defaultPropTypes = {}

export default DistributionGroupRepositoryDescription
